<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="materialStatistics">
            <van-nav-bar
                title="用料统计"
                left-text="应用"
                left-arrow
                @click-left="onClickLeft"
            >
                <van-icon
                    class="iconfont iconshaixuan"
                    slot="right"
                    @click="showPopup()"
                ></van-icon>
            </van-nav-bar>
            <section>
                <div class="head">
                    <div class="headContent">
                        <h4>数据展示</h4>
                        <ul>
                            <li class="customerNumber">
                                <h5 class="iconfont iconyewuyuanguanli">
                                    客户数(个)
                                </h5>
                                <p>23</p>
                            </li>
                            <li class="engineeringNumber">
                                <h5 class="iconfont iconshigonggongdi">
                                    工程数(个)
                                </h5>
                                <p>36</p>
                            </li>
                            <li class="orderNumber">
                                <h5 class="iconfont icondingdanqueren">
                                    订单数(个)
                                </h5>
                                <p>512</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <van-tabs v-model="active">
                    <van-tab title="01～08"></van-tab>
                    <van-tab title="09～16"></van-tab>
                    <van-tab title="17～24"></van-tab>
                    <van-tab title="25～32"></van-tab>
                </van-tabs>
                <div
                    class="chart"
                    id="myChart"
                ></div>
                <ul class="customerList">
                    <li>
                        <div class="customerName">
                            <img class="van_left" src="@/assets/images/materialStatistics/rank_1@2x.png" alt="">
                            <div class="van_left">
                                <h4>A客户</h4>
                                <p>工程名称:北京大兴国际机场</p>
                            </div>
                        </div>
                        <table>
                            <tr>
                                <th>66</th>
                                <th>213</th>
                                <th>769</th>
                                <th>123万</th>
                                <th>263</th>
                            </tr>
                            <tr>
                                <td>订单数</td>
                                <td>累计车次</td>
                                <td>累计方量(m³)</td>
                                <td>欠款金额(¥)</td>
                                <td>超发方量(m³)</td>
                            </tr>
                        </table>
                    </li>
                    <li>
                        <div class="customerName">
                            <img class="van_left" src="@/assets/images/materialStatistics/rank_2@2x.png" alt="">
                            <div class="van_left">
                                <h4>B客户</h4>
                                <p>工程名称:北京大兴国际机场</p>
                            </div>
                        </div>
                        <table>
                            <tr>
                                <th>66</th>
                                <th>213</th>
                                <th>769</th>
                                <th>123万</th>
                                <th>263</th>
                            </tr>
                            <tr>
                                <td>订单数</td>
                                <td>累计车次</td>
                                <td>累计方量(m³)</td>
                                <td>欠款金额(¥)</td>
                                <td>超发方量(m³)</td>
                            </tr>
                        </table>
                    </li>
                    <li>
                        <div class="customerName">
                            <img class="van_left" src="@/assets/images/materialStatistics/rank_3@2x.png" alt="">
                            <div class="van_left">
                                <h4>C客户</h4>
                                <p>工程名称:北京大兴国际机场</p>
                            </div>
                        </div>
                        <table>
                            <tr>
                                <th>66</th>
                                <th>213</th>
                                <th>769</th>
                                <th>123万</th>
                                <th>263</th>
                            </tr>
                            <tr>
                                <td>订单数</td>
                                <td>累计车次</td>
                                <td>累计方量(m³)</td>
                                <td>欠款金额(¥)</td>
                                <td>超发方量(m³)</td>
                            </tr>
                        </table>
                    </li>
                </ul>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 用料统计
    name: 'material-statistics',
    components: {},
    props: {},
    data() {
        return {
            active: 0,
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {
        this.initCharts();
    },
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 过滤
        showPopup() {},
        // 基于准备好的dom，初始化echarts实例
        initCharts() {
            // 基于准备好的dom，初始化echarts实例
            const myChart = this.$echarts.init(document.getElementById('myChart'));
            // 指定图表的配置项和数据
            const option = {
                legend: {
                    x: '74%',
                    y: 10,
                    data: ['累计方量', '超限方量'],
                },
                color: ['#289df5', '#fbc01b', '#ff5050'],
                grid: {
                    left: 15,
                    right: 15,
                    bottom: 15,
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                        },
                    },
                    axisLabel: {
                        interval: 0,
                        textStyle: {
                            fontSize: '12',
                            color: '#979EA7',
                        },
                    },
                    data: ['A客户', 'B客户', 'C客户', 'D客户', 'E客户', 'F客户', 'G客户', 'H客户'],
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#D7D7D7',
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#a3a4b2',
                        },
                    },
                    name: '单位(万方)',
                    nameTextStyle: {
                        color: '#979EA7',
                    },
                    nameGap: 20,
                },
                series: [{
                    name: '累计方量',
                    type: 'bar',
                    smooth: true,
                    barWidth: 6,
                    itemStyle: {
                        normal: {
                            color: '#FD6F64',
                            lineStyle: {
                                color: '#FD6F64',
                            },
                            label: {
                                show: true,
                                position: 'top',
                            },
                        },
                    },
                    data: [8, 15, 18, 9, 21, 15, 10, 10],
                }, {
                    name: '超限方量',
                    type: 'bar',
                    smooth: true,
                    barWidth: 6,
                    itemStyle: {
                        normal: {
                            color: '#51A6FE',
                            lineStyle: {
                                color: '#51A6FE',
                            },
                            label: {
                                show: true,
                                position: 'top',
                            },
                        },
                    },
                    data: [14, 21, 28, 14, 23, 21, 14, 14],
                }],
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        },
    },
};
</script>
<style lang="stylus" scoped>
.materialStatistics
    height 100%
    section
        height calc(100% - 45rpx)
        overflow scroll
        -webkit-overflow-scrolling touch
        .head
            height 173rpx
            padding 14rpx
            background #101077
            .headContent
                background #ffffff
                height 100%
                border-radius 4px
                padding 20rpx 20rpx 0
                h4
                    font-size 16rpx
                    color #333333
                ul
                    overflow hidden
                    margin-top 15rpx
                    li
                        float left
                        width calc(100%/3)
                        text-align center
                        h5
                            font-size 14rpx
                            color #979EA7
                            margin-bottom 10rpx
                        p
                            display inline-block
                            font-size 24rpx
                            color #979EA7
                            width 80rpx
                            height 40rpx
                            line-height 40rpx
                            border-radius 4rpx
                        &.customerNumber
                            p
                                color #3495FB
                                background rgba(52, 149, 251, 0.1)
                        &.engineeringNumber
                            p
                                color #F55244
                                background rgba(245, 82, 68, 0.1)
                        &.orderNumber
                            p
                                color #17BC84
                                background rgba(23, 188, 132, 0.1)

        .chart
            height 270rpx
            border-bottom 15rpx solid #F0F0F0
        .customerList
            li
                padding 15rpx
                border-bottom 1px solid #F0F0F0
                .customerName
                    overflow hidden
                    img
                        width 35rpx
                        height 35rpx
                    div
                        margin-left 15rpx
                        h4
                            font-size 14rpx
                            color #061F3E
                        p
                            font-size 10rpx
                            color #979EA7
                table
                    width 100%
                    margin-top 14rpx
                    th
                        font-size 14rpx
                        color #50A5FE
                        text-align center
                    td
                        font-size 10rpx
                        color #979EA7
</style>